import React, { useState, forwardRef, useEffect } from 'react'

//context
import { useStepsContext } from '../../../../../../contexts/StepsContext'
import { useFieldsContext } from '../../../../../../contexts/FieldsContext'

//images
import editIcon from '../../../../../../assets/img/pages/icons/edit-field.jpg'

import SignPanel from '../../../../../partials/SignPanel'

function Fields(props, ref) {
    const stepsContext = useStepsContext()
    const fieldsContext = useFieldsContext()

    const fieldsData = {
        company: {},
        object: {},
    }

    const [fields, setFields] = useState(fieldsData);

    const editable = props.editable || false
    const original = props.original

    useEffect(() => {
        if (original) setFields(original)
    }, [original])

    return (
        <div className="panel">
            <div className="row">

                <div className="col col-auto">
                    <h3>
                        <span>
                            1
                        </span>
                        Дата
                    </h3>
                    <div className="holder">
                        <div className="row">
                            <div className="col able-to-edit">
                                <label htmlFor="contract_date">
                                    Дата
                                </label>
                                {fields && fields.contract_date && <img
                                    src={editIcon}
                                    alt="edit"
                                    className="edit"
                                    onClick={e => fieldsContext.handleEdit(e)}
                                />}
                                <input autoComplete="off" role="presentation"
                                    id="contract_date"
                                    name="contract_date"
                                    type="date"
                                    defaultValue={fields && fields.contract_date_formatted ? fields.contract_date_formatted : fieldsContext.today()}
                                    readOnly={fields && fields.contract_date ? true : false}
                                />
                            </div>

                        </div>
                    </div>
                </div>

                <div className="col">
                    <div className="row">
                        <div className="col">
                            <h3>
                                <span>
                                    2
                                </span>
                                Данни за заявителя
                            </h3>
                            <div className="holder">

                                {!fields.applicant_type || fields.applicant_type === 'company'
                                    ?
                                    <div className="col">

                                        <div className="row">

                                            <div className="col able-to-edit">
                                                <label htmlFor="company_name">
                                                    Точно наименование на фирмата
                                        </label>
                                                <input autoComplete="off" role="presentation"
                                                    type="text"
                                                    id="company_name"
                                                    value={fields && fields.company && fields.company.name}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col able-to-edit">
                                                <label htmlFor="company_eik">
                                                    ЕИК / Булстат
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="company_eik"
                                                    type="text"
                                                    value={fields && fields.company && fields.company.eik}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col able-to-edit">
                                                <label htmlFor="company_phone">
                                                    Тел. номер
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="company_phone"
                                                    type="text"
                                                    value={fields && fields.company && fields.company.phone}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="row">

                                            <div className="col able-to-edit">
                                                <label htmlFor="company_town">
                                                    Населено място
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="company_phone"
                                                    type="text"
                                                    value={fields && fields.company && fields.company.town
                                                        ? fields.company.town.id
                                                            ? `${fields.company.town.kind} ${fields.company.town.name}`
                                                            : fields.company.town.name
                                                        : ''}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col able-to-edit">
                                                <label htmlFor="company_street">
                                                    Улица
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="company_phone"
                                                    type="text"
                                                    value={fields && fields.company && fields.company.street ? `${fields.company.street.suff} ${fields.company.street.name}` : ''}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col">
                                                <div className="row">
                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="company_street_number">
                                                            №
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="company_street_number"
                                                            type="text"
                                                            value={fields && fields.company && fields.company.street_number}
                                                            readOnly
                                                            min="0"
                                                            step="1"
                                                        />
                                                    </div>

                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="company_entrance">
                                                            Вход
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="company_entrance"
                                                            type="text"
                                                            value={fields && fields.company && fields.company.entrance}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="company_block">
                                                            Блок
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="company_block"
                                                            type="text"
                                                            value={fields && fields.company && fields.company.block}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="company_floor">
                                                            Етаж
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="company_floor"
                                                            type="text"
                                                            value={fields && fields.company && fields.company.floor}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <label htmlFor="company_mol">
                                                    МОЛ
                                                </label>

                                                <input autoComplete="off" role="presentation"
                                                    id="mol"
                                                    type="text"
                                                    value={fields && fields.company && fields.company.mol}
                                                    readOnly={true}
                                                />
                                            </div>

                                            <div className="col">

                                            </div>

                                            <div className="col">

                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className="col">


                                        <div className="row">
                                            <div className="col able-to-edit">
                                                <label htmlFor="applicant_name">
                                                    Трите имена на лицето
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="applicant_name"
                                                    type="text"
                                                    value={fields && fields.applicant && fields.applicant.name}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col able-to-edit">
                                                <label htmlFor="applicant_egn">
                                                    ЕГН
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="applicant_egn"
                                                    type="text"
                                                    value={fields && fields.applicant && fields.applicant.egn}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col able-to-edit">
                                                <label htmlFor="applicant_phone">
                                                    Тел. номер
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="applicant_phone"
                                                    type="text"
                                                    value={fields && fields.applicant && fields.applicant.phone}
                                                    readOnly
                                                />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col able-to-edit">
                                                <label htmlFor="applicant_town">
                                                    Населено място
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="applicant_town"
                                                    type="text"
                                                    value={fields && fields.applicant && fields.applicant.town
                                                        ? fields.applicant.town.id
                                                            ? `${fields.applicant.town.kind} ${fields.applicant.town.name}`
                                                            : fields.applicant.town.name
                                                        : ''}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col able-to-edit">
                                                <label htmlFor="applicant_street">
                                                    Улица
                                                </label>
                                                <input autoComplete="off" role="presentation"
                                                    id="applicant_street"
                                                    type="text"
                                                    value={fields && fields.applicant && fields.applicant.street ? `${fields.applicant.street.suff} ${fields.applicant.street.name}` : ''}
                                                    readOnly
                                                />
                                            </div>

                                            <div className="col">
                                                <div className="row">
                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="applicant_street_number">
                                                            №
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="applicant_street_number"
                                                            type="number"
                                                            min="0"
                                                            step="1"
                                                            className="field-small"
                                                            value={fields && fields.applicant && fields.applicant.street_number}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="applicant_entrance">
                                                            Вход
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="applicant_entrance"
                                                            type="text"
                                                            className="field-small"
                                                            value={fields && fields.applicant && fields.applicant.entrance}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="applicant_block">
                                                            Блок
                                                        </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="applicant_block"
                                                            type="text"
                                                            className="field-small"
                                                            value={fields && fields.applicant && fields.applicant.block}
                                                            readOnly
                                                        />
                                                    </div>

                                                    <div className="col col-auto able-to-edit">
                                                        <label htmlFor="applicant_floor">
                                                            Етаж
                                                </label>
                                                        <input autoComplete="off" role="presentation"
                                                            id="applicant_floor"
                                                            type="text"
                                                            className="field-small"
                                                            value={fields && fields.applicant && fields.applicant.floor}
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div className="row">
                <div className="col">
                    <h3>
                        <span>
                            3
                        </span>
                        Условия и детайли
                    </h3>
                    <div className="holder">

                        <div className="row">
                            <div className="col able-to-edit">
                                <label htmlFor="license_text">
                                    Разполагане на вид съоръжения
                                </label>
                                <input autoComplete="off" role="presentation"
                                    type="text"
                                    id="license_text"
                                    value={fields && fields.license_text}
                                    readOnly
                                />
                            </div>

                            <div className="col">
                                <div className="row">
                                    <div className="col col-auto able-to-edit">
                                        <label>
                                            Зона
                                        </label>
                                        <input autoComplete="off" role="presentation"
                                            type="text"
                                            className="field-medium"
                                            value={fields && fields.street_zone && fields.street_zone.text}
                                            readOnly={true}
                                        />
                                    </div>

                                    <div className="col col-auto able-to-edit">
                                        <label>
                                            Цена
                                        </label>

                                        <input autoComplete="off" role="presentation"
                                            type="text"
                                            className="field-medium"
                                            value={fields && fields.order_selected_price}
                                            readOnly={true}
                                        />
                                    </div>

                                    <div className="col col-auto">
                                        <label>Тип цена</label>
                                        <select
                                            className="field-medium"
                                            readOnly={true}
                                        >
                                            {fields && fields.available_prices_types && Object.entries(fields.available_prices_types).map(p =>
                                                <option
                                                    value={p[0]}
                                                    selected={fields && fields.order_selected_price_type_id == p[0]}
                                                >
                                                    {p[1]}
                                                </option>
                                            )}
                                        </select>
                                    </div>

                                    <div className="col col-auto able-to-edit">
                                        <label htmlFor="license_area_size">
                                            Площ
                                        </label>
                                        <div className="row extra-holder">
                                            <div className="extra-holder">

                                                <input autoComplete="off" role="presentation"
                                                    id="license_area_size"
                                                    type="text"
                                                    // name="license_area_size"
                                                    className="field-medium"
                                                    defaultValue={fields && fields.license_area_size ? fields.license_area_size : fields.request_area_size}
                                                    readOnly={true}
                                                />

                                                <input autoComplete="off" role="presentation"
                                                    type="hidden"
                                                />
                                            </div>
                                            <span className="extra-label">
                                                кв.м.
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>

                        <div className="row">
                            <div className="col col-auto able-to-edit">
                                <label>
                                    Съгласно член
                                </label>
                                {fields && fields.contract_law_article_no && <img
                                    src={editIcon}
                                    alt="edit"
                                    className="edit"
                                    onClick={e => fieldsContext.handleEdit(e)}
                                />}
                                <input autoComplete="off" role="presentation"
                                    id="contract_law_article_no"
                                    name="contract_law_article_no"
                                    className="field-small"
                                    type="text"
                                    defaultValue={fields && fields.contract_law_article_no ? fields.contract_law_article_no : 19}
                                    readOnly={fields && fields.contract_law_article_no ? true : false}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col col-auto able-to-edit">

                                {fields && fields.license_periods && fields.license_periods.map((period, i) =>
                                    <div key={'period-' + period.id} className={['row period'].join(' ')}>
                                        <div className="col">
                                            <label>
                                                Срок от
                                            </label>

                                            <input autoComplete="off" role="presentation"
                                                type="date"
                                                // name="license_period_from[]"
                                                defaultValue={period.from_formatted}
                                                readOnly={true}
                                            />
                                        </div>
                                        <div className="col">
                                            <label>
                                                Срок до
                                            </label>

                                            <input autoComplete="off" role="presentation"
                                                type="date"
                                                // name="license_period_to[]"
                                                defaultValue={period.to_formatted}
                                                readOnly={true}
                                            />
                                        </div>

                                    </div>
                                )}


                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col col-small">
                    <SignPanel
                        panelName="contract_signature"
                        mayor={fields && fields.contractmayorsignature}
                        mayorInput="contract_signed_by_mayor"
                        mayorReason={fields && fields.contract_signed_by_mayor_reason}
                        accountant={fields && fields.contractaccountantsignature}
                        accountantInput="contract_signed_by_accountant"
                        prepared={fields && fields.contractpreparedsignature}
                        preparedInput="contract_prepared_by"
                        agreed={fields && fields.contract_commission_text}
                        agreedInput="contract_commission"
                        handleModify={props.handleModify}
                    />
                </div>
            </div>

        </div>
    )
}

export default forwardRef(Fields)